import { store } from "../../store/store";
import { setMessage } from "../../store/slices/Notification";

export const capitalizeFirstLetter = (value: string) => {
  return value?.charAt?.(0)?.toUpperCase() + value?.slice?.(1);
};

export const formatIsoStringToNormalizedString = (value: string) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based in JavaScript
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  // Construct the custom formatted string
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export function convertHtmlToPlainText(htmlString?: string) {
  if (htmlString) {
    var doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  }
  return "";
}

export const changeSortValue = (value: "asc" | "desc" | null | undefined) => {
  return value === "asc" ? "desc" : "asc";
};
export const slugify = (value: string) => {
  let newValue = "";
  newValue = value.replace(/^\s+|\s+$/g, "");
  newValue = newValue.toLowerCase();
  newValue = newValue
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
  return newValue;
};
export const generateSlug = async ({
  completeData,
  slugDependencies,
  setValue,
  onBreak,
}: {
  completeData: any;
  slugDependencies?: {
    label: string;
    key: string;
    hasApiCall: boolean;
    func: (value: string) => Promise<any>;
  }[];
  setValue: (value: string) => void;
  onBreak: () => void;
}) => {
  let hashData: any = {};
  let requiredDataArray: any[] = [];
  let hasApiCall: boolean = false;
  let shouldBreak = false;
  if (slugDependencies) {
    slugDependencies.forEach((item, index) => {
      if (!shouldBreak) {
        console.log("completeData", completeData, item, completeData[item.key],item.key);

        if (completeData[item.key]) {
          requiredDataArray.push(completeData[item.key]);
        } else {
          store.dispatch(
            setMessage({
              type: "warning",
              message: `The following field is required to generate slug : ${item.label}`,
            })
          );
          shouldBreak = true;
          onBreak();
        }
        if (item.hasApiCall) {
          hasApiCall = true;
        }
        hashData[item.label] = item;
      }
    });
    if (!shouldBreak) {
      if (hasApiCall) {
        const newRequiredDataArray = await Promise.all(
          slugDependencies.map(async (item) => {
            if (item.hasApiCall) {
              const resp = await item.func(completeData[item.key]);
              switch (item.label) {
                case "model":
                  return [resp?.make?.name, "-", resp?.name];
                case "make":
                  return [resp?.name];
                default:
                  return [];
              }
            } else {
              return completeData[item.key];
            }
          })
        );
        setValue(slugify(newRequiredDataArray.join(", ")));
      } else {
        setValue(slugify(requiredDataArray.join(", ")));
      }
    }
  }
};

export const convertDateObjectIntoUserReadableDate = (timestamp: string) => {
  const date = new Date(timestamp);
  const year = date.getFullYear().toString().substr(-2);
  const month = (date.getMonth() + 1).toString().padStart(2);
  const day = date.getDate().toString().padStart(2);
  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2);
  const timePeriod = date.getHours() >= 12 ? "PM" : "AM";
  const formattedDate = `${day}/${month}/${year} ${hours}:${minutes} ${timePeriod}`;
  return formattedDate;
};

export function removeDuplicates(array: any[]): any {
  let seen: { [key: number]: boolean } = {};

  if (array) {
    const result = array.filter(function (item) {
      if (item.id)
        return seen.hasOwnProperty(item.id) ? false : (seen[item.id] = true);
      return true;
    });
    return result;
  }
}

export const convertDataAndTime = (timestamp: string) => {
  return timestamp
    .split("T")
    .join(" ")
    .replace(/\.\d{3}Z/, "");
};

export const imageExtensions = [
  "jpg",
  "jpeg",
  "png",
  "bmp",
  "tiff",
  "tif",
  "webp",
  "ico",
  "heif",
  "heic",
];

export const videoExtensions = [
  ".mp4",
  ".avi",
  ".mov",
  ".wmv",
  ".flv",
  ".webm",
  ".mkv",
  ".3gp",
  ".m4v",
  ".mpg",
  ".mpeg",
  ".ogv",
  ".ts",
  ".vob",
  ".rm",
  ".rmvb",
  ".asf",
  ".mxf",
  ".f4v",
  ".m2ts",
  ".m3u8",
];

export const convertToIST = (dateString: string): string => {
  const date = new Date(dateString);

  // Convert to IST (UTC + 5:30)
  const offsetIST = 5.5 * 60 * 60 * 1000;
  const istDate = new Date(date.getTime() + offsetIST);

  // Format the date
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Asia/Kolkata",
  };
  let formattedDate = istDate.toLocaleDateString("en-IN", options);
  formattedDate = formattedDate.replace("am", "AM").replace("pm", "PM");

  return formattedDate;
};
